import React from 'react';
import { Grid } from '@material-ui/core';
import { FullField } from 'components/CustomFields/CustomFields.jsx';
import NumberInput from 'components/Wrappers/materialUIWrappers/components/NumberInput';
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import { requiredDropdown, required } from 'helpers/ValidationHelpers';
import store from 'store';
import {
	DIncomeProtector,
	getValidationCriteria,
	validateCriteria
} from '../BenifitCompanyValidation';
import CompanyErrorBlock from '../../components/CompanyErrorBlock';
import { get } from 'lodash';

const min2k = value => {
	if (value === undefined) return undefined;

	if (parseInt(value, 10) < 2000.0) {
		return 'Must be greater than R2 000';
	}
	return undefined;
};

class DeathIncomeProtector extends React.PureComponent {
	state = {
		companyCriteria: null,
		toAge: null
	};

	componentDidMount() {
		this.setValidationCriteria();
	}

	setValidationCriteria = () => {
		let premiumPattern = store.getState().form.quotev2.values.premiumPattern;
		const toAge = this.getToAge();

		const companyCriteria = getValidationCriteria({
			benefitValidationObj: DIncomeProtector,
			targets: this.props.AvailTargetsForBroker,
			selectedTargets: this.props.selectedTargets,
			occupation: this.props.occupation,
			qualification: this.props.qualification,
			premiumPattern: premiumPattern,
			age: this.props.clientAge,
			anualSalary: this.props.clientAnualSalary,
			toAge: toAge
		});

		this.setState({ companyCriteria: companyCriteria, toAge: toAge });

		return companyCriteria;
	};

	getToAge = () => {
		let toAge = get(
			store.getState().form.quotev2.values,
			'DeathCeaseAge',
			'validationError'
		);
		if (toAge === 'validationError') toAge = '70';
		return toAge;
	};

	mat75Validate = value => {
		if (this.props.mat75 && this.props.mat100 > 0) {
			if (parseFloat(value) > this.props.mat100) {
				return 'Higher than max available';
			}
		}

		if (value === undefined) return undefined;

		return isNaN(Number(value)) ? 'Must be a number' : undefined;
	};

	deathCeaseAgeValidate = value => {
		if (value === undefined) return undefined;
		let theValue = value;

		
		return undefined;
	};

	render() {
		let companyErrors = {};

		if (this.state.companyCriteria) {
			let companyCriteria = { ...this.state.companyCriteria };

			if (this.getToAge() !== this.state.toAge) {
				companyCriteria = this.setValidationCriteria();
			}

			const coverAmount = get(
				store.getState().form.quotev2,
				'values.deathIncomeCover',
				0
			);

			companyErrors = validateCriteria(
				companyCriteria,
				{
					amount: coverAmount,
					age: this.props.clientAge
				},
				2000.0,
				this.props.mat100
			);
		}

		const benefitValid = Object.keys(companyErrors).length < 1;
		this.props.setBenefitValidity(benefitValid);

		return (
			<Grid container>
				{this.props.mat100 && this.props.mat100 > 0 && (
					<Grid item xs={12} sm={12} md={12}>
						<p>Max available: R{parseFloat(this.props.mat100).toFixed(2)}</p>
					</Grid>
				)}

				<FullField
					name={'deathIncomeCover'}
					label={'Monthly Cover *'}
					component={NumberInput}
					onChange={() => this.forceUpdate()}
					prefix="R"
					seperator=" "
					checkValidation={this.props.checkValidation}
					isrequired={true}
					validate={[required, this.mat75Validate, min2k]}
				/>
				<FullField
					name={'deathIncomeCeaseAge'}
					label={'Cease age *'}
					component={FormDropdown}
					onChange={() => this.forceUpdate()}
					checkValidation={this.props.checkValidation}
					isrequired={true}
					validate={[requiredDropdown]}
					options={[
						{ value: 'validationError', displayValue: 'Please select' },
						{ value: '60', displayValue: '60' },
						{ value: '65', displayValue: '65' },
						{ value: '70', displayValue: '70' }
					]}
				/>
				{!benefitValid ? (
					<Grid item xs={12} sm={12} md={12}>
						<CompanyErrorBlock companyErrors={companyErrors} />
					</Grid>
				) : null}
			</Grid>
		);
	}
}

export default DeathIncomeProtector;



// WEBPACK FOOTER //
// ./src/views/MedicalAidQuote/QuoteWizard/steps/BenefitQuestions/DeathIncomeProtector.jsx